import { useParams } from "react-router-dom";
import { TournamentStatusForm } from "./components";
import { tournamentStatusService } from "@/frontend/services";
import type { TournamentStatusResponseDTO } from "@/shared/dto";
import { useGetId } from "@/frontend/hooks/useGetId";
import { Spin } from "@/frontend/components/common";

export function UpdateTournamentStatusPage() {
  const { id } = useParams<{ id: string }>();
  const { data: statusData, loading: statusLoading } =
    useGetId<TournamentStatusResponseDTO>({
      fetchFn: tournamentStatusService.getById,
      redirectUrl: "/tournament-statuses",
      errorMessage: "Error al cargar el estado de torneo",
      id,
    });

  if (statusLoading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm w-full">
        <div className="flex justify-center items-center py-12">
          <Spin size="large" tip="Cargando..." />
        </div>
      </div>
    );
  }
  if (!statusData) {
    return null;
  }

  const initialValues = {
    name: statusData.name,
    description: statusData.description || "",
    color: statusData.color || "",
    slug: statusData.slug,
    isActive: statusData.isActive,
    sortOrder: statusData.sortOrder,
    isSystem: statusData.isSystem,
    canDelete: statusData.canDelete,
    canEdit: statusData.canEdit,
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="mb-6">
        <h2 className="text-2xl font-bold">Editar Estado de Torneo</h2>
        <p className="text-gray-600 mt-1">
          Actualiza la información del estado seleccionado.
        </p>
      </div>
      <TournamentStatusForm
        tournamentStatusId={id}
        initialValues={initialValues}
      />
    </div>
  );
}
